<!-- modal assign broker -->
<div class="modal fade modal--note" id="modal-assign-broker" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content modal-premium">
      <div class="modal-premium__heading">
        <div class="container">
          <h5>Select the Brokerage and Broker from the drop downs below</h5>
          @if (mode === 'Quotes') {
            <div class="container">
              <p class="text-muted"><small><strong>Note:</strong> Any changes made are implemented immediately.</small></p>
            </div>
          }
          <button class="modal-premium__close" (click)="cancel()">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-premium__content">
        <div class="container">
          <div class="form-group">
            <label>Brokerage</label>
            <select class="form-control" [(ngModel)]="selectedBrokerage" (change)="onBrokerageChange()">
              <option [ngValue]="null">Select brokerage</option>
              @for (b of brokerages; track b) {
                <option [ngValue]="b.insurer_id">{{b.short_name}}</option>
              }
            </select>
          </div>
          <div class="form-group">
            <label>Broker User</label>
            <select class="form-control" [(ngModel)]="selectedBrokerUser" [disabled]="!selectedBrokerage || !brokerUsers.length">
              <option [ngValue]="null">Select broker user</option>
              @for (u of brokerUsers; track u) {
                <option [ngValue]="u.person_id">{{u.first_name}} {{u.last_name}}</option>
              }
            </select>
          </div>
        </div>
      </div>

      <div class="modal-premium__button">
        <div class="container">
          <div class="row row--sm align-items-center">
            <div class="col">
              <a href="javascript:;" (click)="cancel()" class="button button--secondary button--lg">Cancel</a>
            </div>
            <div class="col">
              <a href="javascript:;" (click)="confirm()"
                [ngClass]="{'button--loading': isLoading, 'disabled': !selectedBrokerage || !selectedBrokerUser || isLoading}"
                class="button button--primary button--lg">
                @if (isLoading) {
                  <span class="button__spinner"><span class="spinner"></span></span>
                }
                {{mode === 'Policies' ? 'Save' : 'Confirm'}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal assign broker -->
